"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasSessionStorage = exports.clearSessionStorage = void 0;

var _array = require("../type-checks/array");

var _string = require("../type-checks/string");

var hasSessionStorage = function (key) {
  try {
    // Destructure sessionStorage from window;
    var _window = window,
        _sessionStorage = _window.sessionStorage; // Set an item in storage;

    _sessionStorage.setItem(key, key); // Remove item from storage;


    _sessionStorage.removeItem(key); // Return boolean if no exception;


    return true;
  } catch (e) {
    // Return boolean if exception;
    return false;
  }
}("hasSessionStorage");

exports.hasSessionStorage = hasSessionStorage;

var clearSessionStorage = function clearSessionStorage(key) {
  // If sessionStorage is available;
  if (hasSessionStorage) {
    if ((0, _string.isStringOfLength)(key)) {
      // Remove item from storage at key;
      sessionStorage.removeItem(key);
    } else if ((0, _array.isArrayOfLength)(key)) {
      // Iterate over key array;
      key.forEach(function (k) {
        // Remove item from storage at key;
        sessionStorage.removeItem(k);
      });
    } else {
      // Empty storage;
      sessionStorage.clear();
    }
  }
};

exports.clearSessionStorage = clearSessionStorage;